import i18n from '@/plugins/i18n';
const connectionsMYGraphs = () => ({
  lineCharts: [
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.total-sessions-and-active-sessions'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac', '#08856e', '#ffffff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_total_sessions,meter_active_sessions',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      show: true,
      showForSingleSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.total-connections-and-active-connections'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac', '#08856e', '#ffffff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_total_connections,meter_active_connections',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      show: true,
      showForSingleSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.available-threads-and-connected-threads'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac', '#08856e', '#ffffff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_available_threads,meter_connected_threads',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      show: true,
      showForSingleSeries: true,
      showMetricDropdown: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.active-cursor'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac', '#08856e', '#ffffff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_active_cursor_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      show: true,
      showForSingleSeries: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.cached-cursor-count'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac', '#08856e', '#ffffff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_cached_cursor_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      show: true,
      showForSingleSeries: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.cursor-requests'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#fdfcac', '#08856e', '#ffffff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_cursor_requests_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.request'),
      },
      show: true,
      showForSingleSeries: true,
      showmetricRate: true,
    },
  ],
});

export default connectionsMYGraphs;
